module.exports = __webpack_public_path__ + "img/thaipost.f7bf5ea7.png";